module.exports = __webpack_public_path__ + "static/media/Man-holding-tablet.a8cf3ddb.jpg";